import { NgClass } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { Checkbox } from 'primeng/checkbox';
import { InputMask } from 'primeng/inputmask';
import { InputText } from 'primeng/inputtext';
import { Select, SelectChangeEvent } from 'primeng/select';
import { PaymentMethodName } from '../../../enums/payment/payment-method-name';
import { BasePaymentMethodData } from '../../../interfaces/payment/base-payment-method-data';
import { PaymentDataService } from '../../../services/payment-data.service';
import { BaseAddPaymentComponent } from '../../base/base-add-payment.component';

@Component({
  selector: 'add-form-payment-category',
  imports: [
    FormsModule,
    Select,
    InputText,
    InputMask,
    NgClass,
    Checkbox,
  ],
  templateUrl: './add-form-payment-method.component.html'
})
export class AddFormPaymentMethodComponent extends BaseAddPaymentComponent implements OnInit {

  protected readonly PaymentMethodName = PaymentMethodName;
  paymentDataService = inject(PaymentDataService);
  paymentMethodList: SelectItem[] = [];

  ngOnInit() {
    this.initPaymentMethodList();
  }

  private initPaymentMethodList() {
    /**
     * check for currently not used payment methods
     * and add to available methods list
     */
    this.paymentDataService.paymentMethodConfig.map(pc => {
      if (pc.enabled && !pc.lockedByAdmin) {
        const usedMethod: BasePaymentMethodData = this.paymentDataService.paymentMethods.find(item => item.name === pc.name);
        if (!usedMethod || !usedMethod.hasPaymentTypes) {
          this.paymentMethodList.push({
            value: pc.name,
            label: this.i18n.i18nLng()[pc.name]
          })
        }
      }
    });
  }

  /**
   * reset bank data or PayPal E-Mail Address
   * @param event
   * @protected
   */
  protected paymentMethodChanged(event: SelectChangeEvent) {

    if ((event.value as PaymentMethodName) === PaymentMethodName.PAYPAL) {
      this.paymentData.accountHolder = null;
      this.paymentData.IBAN = null;
      this.paymentData.BIC = null;
      this.paymentData.bank = null;
    } else {
      this.paymentData.payPalEmailAddress = null;
    }

  }
}
